import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Учет выдачи продовольствия")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: 2,
  class: "font-weight-bold"
}, "Категория граждан", -1)
const _hoisted_3 = ["colspan"]
const _hoisted_4 = {
  key: 0,
  rowspan: 2,
  class: "font-weight-bold",
  title: "По категориям граждан"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["title"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { title: "По продовольственным категориям" }, "Итого:", -1)
const _hoisted_12 = {
  key: 0,
  class: "font-weight-bold"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["colspan"]

import { Ref, computed, ref } from 'vue'
import {
  ActualIssueProductsService,
  MunicipalEntitiesService,
  MunicipalEntity,
  GlobalSettingsService,
  GlobalSettings,
  Paging,
  ProductCategory,
  CitizenCategory,
  enumGetKeys,
  PRODUCT_CATEGORIES_INFO,
  citizenCategoryName,
  citizenCategoryShorthand,
  GroupedByMEActualIssueProduct,
  AppAuthService,
  Permissions,
  PRODUCT_CATEGORIES_REPORTS_UNITS_FULL,
} from '@prodcard/core'
import { AdditionalOptsWorksheet, TableVariant } from '../../interfaces'
import { Workbook } from 'exceljs'
import { usePaginator, Paginator, useAuthPermissions } from '../../../../mixins'
import { Pagination } from '../../../../components'
import FilterBox, { SearchParams } from './FilterBox.vue'
import { createCtx, useWatcherSavedRef, handleError } from '../../../../helpers'
import { createSheetActualIssueProducts } from './createSheetActualIssueProducts'
import { saveWorkbook } from '../../../../common'
import { toArray, round } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActualIssueProductsListPage',
  props: {
    actualIssueProductsService: {},
    municipalEntitiesService: {},
    globalSettingsService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;



const { currentMunicipalEntityId, hasPermissions } = useAuthPermissions(props.authService)
const hasView = computed(() => hasPermissions(Permissions.ACTUAL_ISSUE_PRODUCTS_VIEW))
const hasMeView = computed(() => hasPermissions(Permissions.ME_ACTUAL_ISSUE_PRODUCTS_VIEW))
const hasManage = computed(
  () =>
    hasPermissions(Permissions.ACTUAL_ISSUE_PRODUCTS_MANAGE) ||
    hasPermissions(Permissions.ME_ACTUAL_ISSUE_PRODUCTS_MANAGE),
)

const productCategoryList = enumGetKeys(ProductCategory)
const citizenCategoryList = enumGetKeys(CitizenCategory)
const actualIssueProducts: Ref<GroupedByMEActualIssueProduct[]> = ref([])
const globalSettings: Ref<GlobalSettings | undefined> = ref()
const municipalEntities: Ref<MunicipalEntity[]> = ref([])
const { paginator, count, getPageCount, resetPage } = usePaginator('ActualIssueProductListPaginator', { per: 2 })
const searchParams: Ref<SearchParams> = useWatcherSavedRef('ActualIssueProductListParams', {
  dateFrom: undefined,
  dateTo: undefined,
  municipalEntityId: !hasView.value && hasMeView.value ? currentMunicipalEntityId.value : undefined,
})
const loading = ref(false)
const loadingTableToDownload = ref(false)

const update = (paginator: Paginator, filter: SearchParams) => {
  handleError(async () => {
    const from = (paginator.page - 1) * paginator.per
    const { resActualIssueProducts, resMunicipalEntities } = await fetchData(filter, {
      from: from,
      count: paginator.per,
    })

    municipalEntities.value = resMunicipalEntities.items
    actualIssueProducts.value = resActualIssueProducts.items
    count.value = resActualIssueProducts.total
  }, loading)
}

const fetchData = async (filter: SearchParams, paging?: Paging) => {
  const ctx = createCtx()
  if (!globalSettings.value) {
    globalSettings.value = await props.globalSettingsService.load(ctx)
  }

  const time = globalSettings.value?.reportsCloseTime
  const dateFrom = filter.dateFrom
  const dateTo = filter.dateTo
  const resActualIssueProducts = await props.actualIssueProductsService.formReport(ctx, {
    paging,
    filter: {
      ...filter,
      dateFrom: dateFrom
        ? new Date(
            new Date(dateFrom).setHours(time?.hour() || 0, time?.minute() || 0, time?.second() || 0) - 3600 * 1000 * 24,
          )
        : undefined,
      dateTo: dateTo
        ? new Date(new Date(dateTo).setHours(time?.hour() || 0, time?.minute() || 0, time?.second() || 0))
        : undefined,
    },
  })
  const idsME = resActualIssueProducts.items.map(item => item.municipalEntityId)
  const resMunicipalEntities = await props.municipalEntitiesService.findAll(ctx, { filter: { ids: idsME } })

  return { resActualIssueProducts, resMunicipalEntities }
}

const updateSearchParams = (newSearchParams: SearchParams) => {
  searchParams.value = newSearchParams
  resetPage()
  update(paginator.value, searchParams.value)
}

update(paginator.value, searchParams.value)

const tableVariant: Ref<TableVariant> = useWatcherSavedRef('ActualIssueProductListTableVariant', 'couponsCount')

const fullSumActualConsumption = (actualIssueProduct: GroupedByMEActualIssueProduct, variant: TableVariant): number => {
  return toArray(actualIssueProduct.values).reduce((acc, curr) => {
    toArray(curr).forEach(actualIssueProductValue => {
      acc += actualIssueProductValue[variant]
    })
    return round(acc, 3)
  }, 0)
}

const downloadTable = async (filter: SearchParams) => {
  handleError(async () => {
    const workbook = new Workbook()
    const { resActualIssueProducts, resMunicipalEntities } = await fetchData(filter, {})

    const opts: AdditionalOptsWorksheet = {
      tableVariant: 'actualConsumption',
      actualIssueProducts: resActualIssueProducts.items,
      municipalEntities: resMunicipalEntities.items,
    }
    createSheetActualIssueProducts(workbook, 'Количество талонов', { ...opts, tableVariant: 'couponsCount' })
    createSheetActualIssueProducts(workbook, 'Фактическое потребление', opts)

    await saveWorkbook(workbook, 'Учет_выдачи_продовольствия')
  }, loadingTableToDownload)
}

const decorateProductCategory = (pc: ProductCategory, variant: TableVariant): string => {
  if (variant === 'actualConsumption') {
    return `${PRODUCT_CATEGORIES_INFO[pc].description} ${PRODUCT_CATEGORIES_REPORTS_UNITS_FULL[pc] || ''}`
  } else {
    return PRODUCT_CATEGORIES_INFO[pc].description
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(FilterBox, {
        "default-search-params": _unref(searchParams),
        "municipal-entities-service": _ctx.municipalEntitiesService,
        loading: loading.value,
        class: "my-5",
        "readonly-me": !hasView.value && hasMeView.value,
        onUpdate: updateSearchParams
      }, null, 8, ["default-search-params", "municipal-entities-service", "loading", "readonly-me"]),
      _createElementVNode("div", null, [
        _createVNode(_component_v_radio_group, {
          modelValue: _unref(tableVariant),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tableVariant) ? (tableVariant).value = $event : null)),
          inline: "",
          "hide-details": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_radio, {
              label: "Количество талонов",
              value: "couponsCount"
            }),
            _createVNode(_component_v_radio, {
              label: "Фактическое потребление",
              value: "actualConsumption"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_v_card, {
        class: "mt-3",
        loading: loading.value,
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, {
            height: actualIssueProducts.value.length > 0 ? 500 : 200,
            hover: "",
            "fixed-header": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_2,
                  _createElementVNode("th", {
                    colspan: _unref(productCategoryList).length,
                    class: "text-center font-weight-bold"
                  }, " Продовольственная категория ", 8, _hoisted_3),
                  (_unref(tableVariant) !== 'actualConsumption')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_4, " Итого: "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productCategoryList), (productCategory) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: productCategory,
                      class: "text-center font-weight-bold",
                      title: decorateProductCategory(productCategory as ProductCategory, _unref(tableVariant))
                    }, _toDisplayString(_unref(PRODUCT_CATEGORIES_INFO)[productCategory as ProductCategory].shorthand), 9, _hoisted_5))
                  }), 128))
                ])
              ]),
              (actualIssueProducts.value.length > 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actualIssueProducts.value, (actualIssueProduct) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: actualIssueProduct.id
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            colspan: _unref(productCategoryList).length + 1,
                            class: "font-weight-bold"
                          }, _toDisplayString(municipalEntities.value.find(me => me.id === actualIssueProduct.municipalEntityId)?.name), 9, _hoisted_7),
                          (_unref(tableVariant) !== 'actualConsumption')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_8))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizenCategoryList), (citizenCategory) => {
                          return (_openBlock(), _createElementBlock("tr", { key: citizenCategory }, [
                            _createElementVNode("td", {
                              width: "115",
                              title: _unref(citizenCategoryName)(citizenCategory as CitizenCategory)
                            }, _toDisplayString(_unref(citizenCategoryShorthand)(citizenCategory as CitizenCategory)), 9, _hoisted_9),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productCategoryList), (productCategory) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: productCategory,
                                class: "text-center"
                              }, _toDisplayString(_unref(round)(
                    actualIssueProduct.values[citizenCategory as CitizenCategory][productCategory as ProductCategory][
                      _unref(tableVariant)
                    ],
                    3,
                  )), 1))
                            }), 128)),
                            (_unref(tableVariant) !== 'actualConsumption')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(_unref(toArray)(actualIssueProduct.values[citizenCategory as CitizenCategory]).reduce(
                    (acc, curr) => _unref(round)(acc + curr[_unref(tableVariant)], 3),
                    0,
                  )), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        _createElementVNode("tr", null, [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productCategoryList), (productCategory) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: productCategory,
                              class: "text-center"
                            }, _toDisplayString(_unref(toArray)(actualIssueProduct.values).reduce(
                    (acc, curr) => _unref(round)(acc + curr[productCategory as ProductCategory][_unref(tableVariant)], 3),
                    0,
                  )), 1))
                          }), 128)),
                          (_unref(tableVariant) !== 'actualConsumption')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(fullSumActualConsumption(actualIssueProduct, _unref(tableVariant))), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    }), 128))
                  ]))
                : (!loading.value)
                  ? (_openBlock(), _createElementBlock("tfoot", _hoisted_13, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          colspan: _unref(productCategoryList).length + 2,
                          class: "text-center",
                          style: {"border-top":"0"}
                        }, "Нет данных", 8, _hoisted_14)
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["height"]),
          _createVNode(_unref(Pagination), {
            modelValue: _unref(paginator),
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
              _cache[2] || (_cache[2] = ($event: any) => (update($event, _unref(searchParams))))
            ],
            "list-items-per-page": [2, 4, 6],
            "page-count": _unref(getPageCount),
            disabled: loading.value || _unref(getPageCount) === 0,
            class: "mt-5"
          }, null, 8, ["modelValue", "page-count", "disabled"])
        ]),
        _: 1
      }, 8, ["loading", "disabled"]),
      _createElementVNode("div", null, [
        (globalSettings.value && globalSettings.value.reportsCloseTime)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              icon: "$info",
              color: "info",
              variant: "outlined",
              "max-width": "550",
              class: "mt-5",
              text: `Внесение данных доступно до ${globalSettings.value.reportsCloseTime.toString()}. Данные, внесенные после ${globalSettings.value.reportsCloseTime.toString()} суммируются в итоги следующего дня.`
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                (hasManage.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      to: "/actual-issue-products/new",
                      class: "mt-5"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Внести данные")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                (_unref(hasPermissions)(_unref(Permissions).ACTUAL_ISSUE_PRODUCTS_TABLE_EXPORT))
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "mt-5",
                      color: "primary",
                      variant: "outlined",
                      "prepend-icon": "mdi-download-outline",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (downloadTable(_unref(searchParams)))),
                      loading: loadingTableToDownload.value,
                      disabled: loading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Скачать ")
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})